module.exports = __webpack_public_path__ + "img/work.67fa7cb0.svg";